/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

/**
 * Nahrazovač napájecích úloh
 */
class PowerTaskReplacer {
  /**
   * @param {Store} primaryStore
   * @param {TaskToPowerTaskConverter} taskConverter
   */
  constructor(primaryStore, taskConverter) {
    this.primaryStore = primaryStore;
    this.taskConverter = taskConverter;
  }

  /**
   * Nahradí napájecí úlohy v perzistentním úložišti za nové.
   * @param {ContentInfo} contentInfo Obsah s novými úlohami
   * @returns {Promise.<Array.<PowerTask>>}
   */
  replace(contentInfo) {
    // TODO DRY ReplacerCommon#replace
    return new Promise((resolve) =>
      resolve(
        this.primaryStore.replaceAsync(
          'powerTask',
          JSON.parse(JSON.stringify(contentInfo.powerTasks)),
          null,
          { onConflict: 'replace' }
        )
      )
    );
  }

  /**
   * Obnoví napájecí úlohy z perzistentího úložiště.
   * @param {Array.<Task>} tasks Obnovené staré úlohy pro případ,
   * že bude nutná migrace ze starého fromátu na nový.
   * @returns {Promise.<Array.<PowerTask>>}
   */
  restore(tasks) {
    return new Promise((resolve) =>
      resolve(
        // Načtou se všechny napájecí úlohy z perzistentního úložiště.
        this.primaryStore.findAll('powerTask').then((powerTasks) => {
          // Pokud se podařilo nějaké úlohy načíst, použijí se.
          if (powerTasks.length) {
            return powerTasks;
          }
          // Bez dostupných napájecí úloh se provede pokus o migraci dat
          // ze starého formátu úloh.
          return tasks.reduce((acc, task) => {
            // Migrace úloh ze statého do nového formátu.
            const powerTask = this.taskConverter.convert(
              this.primaryStore,
              task
            );
            // Ne všechny úlohy jdou převést, použijí se pouze ty, které lze.
            if (!isNil(powerTask)) {
              acc.push(powerTask);
            }
            return acc;
          }, []);
        })
      )
    );
  }
}

export default PowerTaskReplacer;
